var React = require('react');

function ProStar (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M16 23.7618L21.8198 27.2914C22.8856 27.9383 24.1898 26.9821 23.9094 25.7727L22.3667 19.1353L27.5134 14.6635C28.453 13.8479 27.9482 12.301 26.7141 12.2026L19.9407 11.6261L17.2902 5.35428C16.8134 4.21524 15.1866 4.21524 14.7098 5.35428L12.0593 11.612L5.28591 12.1886C4.05183 12.287 3.54698 13.8338 4.48656 14.6494L9.63325 19.1213L8.09065 25.7586C7.81017 26.968 9.11437 27.9242 10.1802 27.2774L16 23.7618Z","fill":"#FFEE55"}));
}

ProStar.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none"};

module.exports = ProStar;

ProStar.default = ProStar;
